import React from 'react';
import { Profile } from '@features/profile/Profile';

const ProfilePage: React.FC = () => {
  return <Profile />;
};

export default ProfilePage;